// components/RoleManagement/RolePermissionEditor.tsx
import {
  Button,
  SimpleGrid,
  Group,
  Title,
  Box,
  Stack,
  Flex,
} from "@mantine/core";
import {
  PermissionType,
  RolePermission,
  UpdateRolePermissionPayload,
} from "constants/types/permission";
import { useAbility } from "configs/casl";
import { useRoleManager } from "utils/hooks/permission/useRoleManager";
import { PermissionGroup } from "../PermissionGroup/PermissionGroup";

interface RolePermissionEditorProps {
  role: string;
  allPermissions: PermissionType[];
  currentRolePermissions: RolePermission[];
  onSave?: (payload: UpdateRolePermissionPayload) => void;
  isLoading?: boolean;
}

export const RolePermissionEditor = ({
  role,
  allPermissions,
  currentRolePermissions,
  onSave,
  isLoading = false,
}: RolePermissionEditorProps) => {
  const ability = useAbility();
  const canSave = ability.can("update", "permission");
  const {
    groupedPermissions,
    selectedCodes,
    togglePermission,
    toggleModule,
    getSubmitPayload,
  } = useRoleManager({ role, allPermissions, currentRolePermissions });

  const handleSave = () => {
    const payload = getSubmitPayload();
    onSave!(payload);
  };

  return (
    <Stack gap="xs">
      {/* Sử dụng Grid để Responsive UI */}
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3, lg: 4 }} spacing="sm">
        {Object.entries(groupedPermissions || {}).map(
          ([moduleName, permissions]) => (
            <PermissionGroup
              key={moduleName}
              moduleName={moduleName}
              permissions={permissions}
              selectedCodes={selectedCodes}
              onTogglePermission={togglePermission}
              onToggleModule={toggleModule}
            />
          ),
        )}
      </SimpleGrid>
      {canSave && (
        <Flex justify={"center"}>
          <Button
            onClick={handleSave}
            loading={isLoading}
            color="blue"
            w={200}
            disabled={!role}
          >
            Lưu phân quyền
          </Button>
        </Flex>
      )}
    </Stack>
  );
};
